const defaultValues = {
    numberOfModules: 1,
    numberOfPeople: 1,
    direction: 4,
    angle: 30,
    consumption: 1500,

  };
  const defaultConsumption = {
    1: 1500,
    2: 2500,
    3: 3000,
    4: 3500,
    5: 4500,
  };
  const directs = {
    1: "N",
    2: "NW",
    3: "W",
    4: "SW",
    5: "S",
    6: "SO",
    7: "O",
    8: "NO",
    9: "N2"
  }
  const directsR2 = {
    1: 270,
    2: 225,
    3: 180,
    4: 135,
    5: 90,
    6: 45,
    7: 0,
    8: -45,
    9: 270
  };
  const diri = {
    1: "0%",
    2: "15%",
    3: "27%",
    4: "38%",
    5: "50%",
  
    6: "63%",
    7: "74%",
    8: "85%",
    9: "100%"
  };

  const inclisList = te={90:{x:"8",y:"241",rotate:"-90 8 241"},75:{x:"6.625",y:"239.111",rotate:"-65.7159 6.625 239.111"},60:{x:"7",y:"238.159",rotate:"-53.4264 7 238.159"},45:{x:"7.0415",y:"237.031",rotate:"-38.7134 7.0415 237.031"},30:{x:"7",y:"235.926",rotate:"-26.5922 7 235.926"},15:{x:"7.86963",y:"234.561",rotate:"-10.2092 7.86963 234.561"},0:{x:"8.57178",y:"234",rotate:"0"}}
  let incliCountEl = document.getElementById("inclination");
  let peopleCountEl = document.getElementById("peoplecount");
  let modulecountEl = document.getElementById("modulecount");
  let directionEl = document.getElementById("direction");
  let manualConsumptionEl = document.getElementById("manualConsumption");
  let radarEl = document.getElementById("activeDir");
  function setDirection(dir){
    if(directionEl){
      directionEl.value = dir;
      let per = dir == 1? 0 : dir*10;
    
      directionEl.style = `background: linear-gradient(to right, rgb(250, 193, 73) 0%, rgb(250, 193, 73) ${per}%, rgb(228, 234, 243) ${per}%, rgb(228, 234, 243) 100%)`
      
    }
    defaultValues.direction = dir;
    const directionList = document.getElementById("directionTicks");
    const it = directionList.getElementsByClassName("o_on");
    
    it[0].classList = "o_txt";
  
    const curr = document.getElementById("d" + directs[dir]);
    curr.classList = "o_txt o_on";
    reCalc();
  }



  let resultEl = document.getElementById("result");
  function setResult(result){
  resultEl.innerText = result;
}
  peopleCountEl.addEventListener("change", (e) => {
    defaultValues.numberOfPeople = +e.target.value;
    const numOfPeople = +e.target.value;
    defaultValues.consumption = defaultConsumption[numOfPeople];
    manualConsumptionEl.value = defaultValues.consumption;
    reCalc();
  });
  manualConsumptionEl.addEventListener("change", (e) => {
    defaultValues.consumption = +e.target.value;
    reCalc();
  });
  modulecountEl.addEventListener("change", (e) => {
    defaultValues.numberOfModules = +e.target.value;
    reCalc();
   
  });
  incliCountEl.addEventListener("change", (e) => {
      defaultValues.angle = +e.target.value;
      const incliList = document.getElementById("incliticks");
      const it = incliList.getElementsByClassName("o_on");
      it[0].classList = "o_txt";
      const curr = document.getElementById("i" + +e.target.value);
     
      let per = +e.target.value/15*16.66;

      incliCountEl.style = `background: linear-gradient(to right, rgb(250, 193, 73) 0%, rgb(250, 193, 73) ${per}%, rgb(228, 234, 243) ${per}%, rgb(228, 234, 243) 100%)`
      
      curr.classList = "o_txt o_on";
      
      reCalc();
     
    });
    directionEl.addEventListener("change", (e) => {
      defaultValues.direction = +e.target.value;
      const directionList = document.getElementById("directionTicks");
      const it = directionList.getElementsByClassName("o_on");
      let per = +e.target.value == 1? 0 : `${(+e.target.value - 1)*12.2}`;
     
      directionEl.style = `background: linear-gradient(to right, rgb(250, 193, 73) 0%, rgb(250, 193, 73) ${per}%, rgb(228, 234, 243) ${per}%, rgb(228, 234, 243) 100%)`
      
      it[0].classList = "o_txt";
    
      const curr = document.getElementById("d" + directs[+e.target.value]);
      curr.classList = "o_txt o_on";
     
      reCalc();
    });
    (function() {
        reCalc();
     
     })();
function reCalc(){
    
    const opts =  {method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    
    body: JSON.stringify({
        consumption: defaultValues.consumption,
        neig: defaultValues.angle,
        fausr: defaultValues.direction,
      },
    )};
    fetch(`https://ertragsrechner-alpha.fly.dev/api/v1/calc`, opts ).then((res) => {
        res.json().then((result) => {
            const multi = defaultValues.numberOfModules == 2? 2: 1;
            let resultEl = document.getElementById("result");
            resultEl.innerText = (multi*result.result.power).toFixed(0) + " " + "kWh";
            let co2El = document.getElementById("co2");
            co2El.innerText = (multi*result.result.co2).toFixed(0) + " " + "kg";
            let selfi = document.getElementById("self");
            selfi.innerText = (multi*result.result.self).toFixed(0) + " " + "kWh";
            let co2PA = document.getElementById("co2PA");
            co2PA.innerText = (multi*result.result.co2pA).toFixed(0) + " " + "kg";
            let savings = document.getElementById("savings");
            savings.innerText = (multi*result.result.savings).toFixed(2) + " " + "€";
            //co2PA
        });
    });
}
